import { css } from '@emotion/css';
import styled from '@emotion/styled';
import Grid from '@mui/material/Grid';
import { colorPalette } from '../../colorPalette';
export const dropzoneClasses = ({ height, disableDropStyle = true }) => {
    return {
        root: css `
      && {
        background-image: unset;
        display: flex;
        justify-content: center;
        height: ${height || '180px'};
        background-color: ${colorPalette.gray100};
        border: 1px dashed ${colorPalette.gray300};
        box-sizing: border-box;
        border-radius: 8px;
        min-height: auto;
        color: ${colorPalette.gray800};
        &:hover {
          background-color: ${colorPalette.gray200};
        }
      }
    `,
        active: disableDropStyle
            ? css `
          && {
            background-color: ${colorPalette.gray200};
          }
        `
            : css `
          && {
            border-color: ${colorPalette.green800};
            background-color: ${colorPalette.green100};
            color: ${colorPalette.green700};
          }
        `,
        invalid: disableDropStyle
            ? css `
          && {
            background-color: ${colorPalette.gray200};
          }
        `
            : css `
          && {
            border-color: ${colorPalette.red800};
            background-color: ${colorPalette.red100};
            color: ${colorPalette.red600};
          }
        `,
        textContainer: css `
      && {
        display: flex;
        flex-direction: column-reverse;
        justify-content: center;
        align-items: center;
        padding: 1rem;
      }
    `,
        text: css `
      && {
        margin: 0;
        font-size: 1.4rem;
        line-height: normal;
        color: ${colorPalette.gray900};
      }
    `,
        icon: css `
      && {
        color: ${colorPalette.gray700};
        width: 32px;
        height: 32px;
        margin-bottom: 1rem;
      }
    `,
    };
};
export const DropContainer = styled(Grid)(() => ({
    '&&': {
        position: 'relative',
    },
}));
export const gridItem = (height) => ({
    height: height || '180px',
    flexBasis: height || '180px',
    flexGrow: 0,
    padding: 4,
});
export const StyledImage = styled('img')(() => ({
    '&&': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: '4px',
    },
}));
export const dropContainerStyle = (height, hideDropzoneAreaAtFileLimit) => ({
    height: height || '180px',
    width: hideDropzoneAreaAtFileLimit ? '100%' : height || '180px',
    padding: '16px',
    margin: hideDropzoneAreaAtFileLimit ? '8px 0 0 8px' : '4px 0 0 8px',
    position: 'relative',
    borderRadius: '8px',
    color: colorPalette.gray800,
    backgroundColor: colorPalette.white,
    border: `1px solid ${colorPalette.gray300}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});
export const cancelIconStyle = {
    position: 'absolute',
    top: '8px',
    right: '8px',
    width: '24px',
    height: '24px',
    color: colorPalette.gray700,
    borderRadius: '50%',
    cursor: 'pointer',
    backgroundColor: colorPalette.white,
};
export const cancelIconStyleForImage = Object.assign(Object.assign({}, cancelIconStyle), { top: '16px', right: '16px' });
export const containerText = {
    color: colorPalette.gray900,
    fontSize: '1.4rem',
    wordBreak: 'break-word',
    textAlign: 'center',
};
export const subtitleText = {
    color: colorPalette.gray600,
    fontSize: '1.3rem',
};
export const fileIconStyle = {
    fontSize: '2.4rem',
    color: colorPalette.gray900,
};
export const fileIconWrapper = {
    marginBottom: '10px',
    padding: '11px',
    borderRadius: '8px',
    backgroundColor: colorPalette.gray200,
};
